var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.value,
          expression: "value",
        },
      ],
      class: _vm.calculateModalClass,
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog",
          attrs: { role: "document" },
        },
        [
          _c("div", { class: _vm.generateContentClass }, [
            _c("div", { staticClass: "jv-modal-header" }, [
              _c("h3", { staticClass: "jv-modal-title" }, [
                _vm._v(_vm._s(_vm.header)),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.close.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("×"),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body" },
              [
                _c(_vm.content, {
                  tag: "component",
                  attrs: { data: _vm.data },
                  on: {
                    close: function ($event) {
                      return _vm.close()
                    },
                    save: _vm.save,
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }